import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './FJSkeletonScreen.module.less';
import FJResourceItemLoading from '../FJResourceItemLoading/FJResourceItemLoading';
import PropTypes from 'prop-types';
/**
 * @description 骨架屏
 */
class FJSkeletonScreen extends Component {
    _getListComp = () => {
        const { list = [], titleClassName, ulClassName, innerClassName, itemClassName } = this.props;
        let arrComp = [];

        list.forEach((item, index) => {
            arrComp.push(
                <div key={index}>
                    <div className={classNames(styles.title, titleClassName)}>
                        <FJResourceItemLoading />
                    </div>
                    <div className={classNames(styles.ul, ulClassName)}>
                        <div className={classNames(styles.inner, innerClassName)}>
                            {item.map((a, iIndex) => (
                                <div
                                    key={index + '' + iIndex}
                                    className={classNames(styles.item, itemClassName)}
                                    style={{ width: a.width + 'px', height: a.height + 'px' }}
                                >
                                    <FJResourceItemLoading />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>,
            );
        });
        return arrComp;
    };

    render() {
        return <>{this._getListComp()}</>;
    }
}
FJSkeletonScreen.propTypes = {
    list: PropTypes.array.isRequired,
    titleClassName: PropTypes.string,
    ulClassName: PropTypes.string,
    innerClassName: PropTypes.string,
    itemClassName: PropTypes.string,
};
export default FJSkeletonScreen;
